import { DialogContent, DialogTitle, Stack, Typography } from "@mui/material";
import { CommonDialog } from "../common/CommonDialog";
import { FormButtonGroup } from "../form";
import { useClinicalRegisterContext } from "../../contexts/ClinicalRegisterContext";
import { useState } from "react";
import { useRelatedPersonVerification } from "@/hooks/useRelatedPersonVerification";
import { getRelatedPersonResourceId } from "@/services/fhir/relatedperson/relatedPersonVerification";
import { RelatedPersonVerificationList } from "./RelatedPersonVerificationList";

export function VerifyResponsibleDialog({
  handleClose,
  isOpen,
  loading,
  setLoading,
  dataAppointment,
  related,
  fetchRelated,
  patientId,
  submit,
}: any) {
  const { verifyEncounter } = useClinicalRegisterContext();
  const [handledIds, setHandledIds] = useState<string[]>([]);

  const {
    isRowLoading,
    isVerifyLoading,
    isDenyLoading,
    handleVerify,
    handleDeny,
    isVerificationInProgress,
  } = useRelatedPersonVerification({
      patientId,
      onAfterVerify: async (entry) => {
        const resourceId = getRelatedPersonResourceId(entry);
        if (resourceId) {
          setHandledIds((prev) =>
            prev.includes(resourceId) ? prev : [...prev, resourceId]
          );
        }
        await fetchRelated();
      },
      onAfterDeny: async (_entry, resourceId) => {
        setHandledIds((prev) =>
          prev.includes(resourceId) ? prev : [...prev, resourceId]
        );
        await fetchRelated();
      },
    });

  const pendingRelated =
    related?.filter(
      (entry: any) =>
        !handledIds.includes(getRelatedPersonResourceId(entry) ?? "")
    ) ?? [];

  return (
    <CommonDialog handleClose={handleClose} isOpen={isOpen}>
      <DialogTitle textAlign="center">
        <Typography variant="h5" fontWeight={600}>
          Responsável
        </Typography>
      </DialogTitle>

      <Typography
        textAlign="center"
        variant="body1"
        color="neutral700.main"
        fontWeight={500}
        mb={1}
      >
        {related?.length
          ? `Após a validação o responsável terá acesso aos registros eletrônicos de
        saúde do paciente`
          : "Verificação finalizada!"}
      </Typography>
      <DialogContent>
        <Stack spacing={2}>
          <RelatedPersonVerificationList
            entries={pendingRelated}
            isRowLoading={isRowLoading}
            isVerifyLoading={isVerifyLoading}
            isDenyLoading={isDenyLoading}
            onVerify={handleVerify}
            onDeny={handleDeny}
            title=""
          />
          <FormButtonGroup
            disabled={
              isVerificationInProgress ||
              (related?.length > 0 && pendingRelated.length > 0)
            }
            onGoBackButtonClick={handleClose}
            onNextButtonClick={async () => {
              setLoading(true);
              submit ? submit() : await verifyEncounter(dataAppointment);
              handleClose();
            }}
            goBackButtonText="Fechar"
            nextButtonText="Prosseguir"
            loading={loading}
          />
        </Stack>
      </DialogContent>
    </CommonDialog>
  );
}
